import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { Title } from '@xsolla/ui-core';

import { useConfig } from '../../../contexts/config';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { StyledAlert, StyledButton, Text, Wrapper } from './style';
import { ErrorPageProps } from './types';

const BackToNavigationError = ({
  history,
  match,
  error,
  pageName
}: ErrorPageProps): JSX.Element => {
  const { navigationPath } = usePaths();
  const intl = useIntl();
  const { projectId } = match.params as RouteParams;
  const { xsollaAnalytics } = useConfig();

  useEffect(() => {
    xsollaAnalytics.sendOpen(`login_pa_module__${pageName}`, 'error', {
      error: error?.description || ''
    });
  }, []);

  const handleClick = () => {
    history.push(navigationPath(projectId));
  };

  return (
    <Wrapper>
      <StyledAlert size={48} />

      <Title center indent="sm">
        {intl.formatMessage({ id: 'app.error.page.label' })}
      </Title>

      <Text>
        <FormattedMessage
          id="app.error.page.text"
          values={{
            br: () => <br />
          }}
        />
      </Text>

      <StyledButton onClick={handleClick}>
        {intl.formatMessage({ id: 'button.to-navigation' })}
      </StyledButton>
    </Wrapper>
  );
};

export default withRouter(BackToNavigationError);
